import {
	ExperienceName,
	useAIMateExperienceTracker,
} from '@atlassian/conversation-assistant-instrumentation';
import { performGqlFetch, useQuery } from '@atlassian/conversation-assistant-service';

import { useSiteContext } from '../site-id';

import type { SitePermissionsResponse, SitePermissionsVariables } from './types';

const AgentPermissionsQuery = `
	query AgentPermissions($cloudId: ID!) {
		atlassianStudio_userSiteContext(cloudId: $cloudId) {
			... on AtlassianStudioUserSiteContextOutput {
				userPermissions {
					isAbleToCreateAgents
				}
			}
		}
	}
`;

export const useAgentSitePermissions = (isEnabled = true, overrideSiteId?: string) => {
	const { siteId } = useSiteContext();
	const experienceTracker = useAIMateExperienceTracker();

	const siteIdToUse = overrideSiteId ?? siteId;

	const query = useQuery({
		queryKey: ['fetchSitePermissions', siteIdToUse],
		queryFn: async () => {
			experienceTracker.start({
				id: ExperienceName.FETCH_AGENT_SITE_PERMISSIONS,
				name: ExperienceName.FETCH_AGENT_SITE_PERMISSIONS,
			});
			return await performGqlFetch<SitePermissionsResponse, SitePermissionsVariables>({
				gqlQuery: AgentPermissionsQuery,
				variables: {
					cloudId: siteIdToUse,
				},
			});
		},
		enabled: isEnabled,
		onSuccess: () => {
			experienceTracker.succeed({
				name: ExperienceName.FETCH_AGENT_SITE_PERMISSIONS,
			});
		},
		onError: (error) => {
			experienceTracker.fail({
				name: ExperienceName.FETCH_AGENT_SITE_PERMISSIONS,
				error,
			});
		},
	});

	return query;
};
